import { SAVE_YF_MANAGER_DATA, SAVE_YF_MANAGER_IMAGE } from './actionTypes'
import { YFPopinDataTypes, YFPopinImageTypes } from './types'
import { YfManagerDataModel, YfManagerImageModel } from '../../../types/yfPopin/yfManagerModel'

export const saveYFManagerImage = (yfManagerData: YfManagerImageModel): YFPopinImageTypes => {
    return (
        {
            type: SAVE_YF_MANAGER_IMAGE,
            payload: yfManagerData
        }
    )
}

export const saveYFManagerData = (yfManagerData: YfManagerDataModel): YFPopinDataTypes => {
    return (
        {
            type: SAVE_YF_MANAGER_DATA,
            payload: yfManagerData
        }
    )
}
